module.exports = __webpack_public_path__ + "static/banner-three-shape6-30de030c3aad7a1654aa820f8b4a748f.png";